// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from "element-ui"
import echarts from "echarts"
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import App from './App'
import router from './router'
import store from './store'
import 'babel-polyfill'

//封装的方法
import './filter/search'
// css
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css'
import http from './common/http'

Vue.use(ElementUI)
Vue.use(VueAxios,axios,qs)
Vue.config.productionTip = false


Vue.prototype.$echarts = echarts
Vue.prototype.$api = http

try {
  //百度统计
  let _hmt = _hmt || [];
  window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
  //关闭了自动PV跟踪
  window._hmt.push(['_setAutoPageview', false]);
  (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?105348eb2dd77b16e19abfd4d419b9b7";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
  })();

} catch(e) {
  console.log('百度统计', e)
}

router.afterEach((to, from) => {
  try {
      //关闭了自动PV跟踪
      window._hmt.push(['_setAutoPageview', false]);

      //  百度统计默认截断#号后面的参数，故通过手动来添加pv
      window._hmt.push(['_trackPageview',  '/'+ location.search +'#' + to.fullPath]);
  } catch(e) {
      console.log('百度统计', e)
  }

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  echarts,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js